import React from 'react';

export const renderAttachment = (attachment) => {
    return attachment ?
        <a href={attachment} style={{ color: `#3f51b5` }} download>
            {attachment.substring(attachment.lastIndexOf('\\')).substring(38)}
        </a>
        : '-'
};